import React, { Component, } from 'react'
import PropTypes from 'prop-types'
import { CCIcon, CCCoinPile,Constants,  strings} from "./../../cc-imports";
// import './cc-league-item.css'
// import './cc-league-item-320x720.css'
import './../../styles/css/components/CCLeagueItem/cc-league-item.css'
import CCErrorBoundary from "../CCErrorBoundary/CCErrorBoundary";
import {colors, images} from './../../cc-imports'

class CCLeagueItem extends Component {

    static propTypes = {
        onPress : PropTypes.func,
        onEntriesPress : PropTypes.func,
        league : PropTypes.object
    }

    static defaultProps = {
        onPress:()=>{},
        onEntriesPress:()=>{}
    }

    constructor(props) {
        super(props)
        this.state = {}
        this._getTitle=this._getTitle.bind(this);
        this._getIconType=this._getIconType.bind(this);
    }

    _getTitle(league){
        switch (league.category){
            case Constants.leagueCategory.DREAMTEAM:
                return strings('dream_team');
                break;
            case Constants.leagueCategory.QUICK_PREDICTION:
            case Constants.leagueCategory.LIVE_PREDICTION:
                return strings('live_prediction');
                break;
            case Constants.leagueCategory.PREDICTION:
                return strings('target_prediction');
                break;
            default:
                return strings('cricrush_league');
        }
    }

    _getDescription(league){
        const qps= league.quickPredictionDetails;
        switch (league.category){
            case Constants.leagueCategory.DREAMTEAM:
                return strings('pick_team');
                break;
            case Constants.leagueCategory.QUICK_PREDICTION:
            case Constants.leagueCategory.LIVE_PREDICTION:
                return strings('predict_what_message', {teamName: qps.team.toUpperCase(), startOver: qps.startOver, endOver: qps.endOver })
                break;
            case Constants.leagueCategory.PREDICTION:
                return strings('predict_score');
                break;
            default:
                return strings('cricrush_league');
        }
    }

    _getCoins(league){
        var coins = league.coinsPerEntry;
        switch (league.type){
            case Constants.leagueType.DOUBLE:
                return coins*2;
                break;
            case Constants.leagueType.TRIPLE:
                return coins*3;
                break;
            case Constants.leagueType.QUADRUPLE:
                return coins*4;
                break;
            case Constants.leagueType.QUINTUPLE:
                return coins*5;
                break;
            default:
                return coins*100;
        }
    }

    _getIconType(league){
        switch (league.category){
            case Constants.leagueCategory.DREAMTEAM:
                return "dreamTeam"
                break;
            case Constants.leagueCategory.QUICK_PREDICTION:
            case Constants.leagueCategory.LIVE_PREDICTION:
                return 'livePrediction'
                break;
            case Constants.leagueCategory.PREDICTION:
                return 'targetPrediction'
                break;
            default:
                return ''
        }
    }

    _getTitle3(league){
        var title=strings('entries_left2',{noOfEntries : (league.maxEntries-league.noOfEntries)});
        if(league.noOfEntries>=2){
            title = strings('view_entries',{noOfEntries : league.noOfEntries});
        }
        return title;
    }

    render() {
        const {league}=this.props;
        const styles = ccStyles.default;
        const disabled = Constants.leagueStatus.isCompleted(league.status) || Constants.leagueStatus.LIVE == league.status;
        return (
            <CCErrorBoundary>
                <div className="flex-container btn" style={{...{flex:1}, ...this.props.style}}>
                    <div className="flex-container cc-league-item-container">
                        <div className="flex-container icon-container">
                            {
                                disabled === true &&
                                <div className={"flex-container league-icon-disabled"}>
                                    <CCIcon className={'cc_league_1_icon'} type={this._getIconType(league)}/>
                                </div>
                            }
                            {
                                disabled === false &&
                                <div className={"flex-container league-icon"}>
                                    <CCIcon className={'cc_league_1_icon'} type={this._getIconType(league)}/>
                                </div>
                            }


                        </div>
                        <div className="flex-container league-content-container">
                            <div className="flex-container league-container" >
                                <h1 className={'title'} style={{color : disabled ? colors.theme2.font_color5 : colors.theme2.font_color4}} onClick={()=>{this.props.onPress(league)}}>{this._getTitle(league)}</h1>
                                <h3 className={'description'} style={{color : disabled ? colors.theme2.font_color5 : colors.theme2.font_color4}} onClick={()=>{this.props.onPress(league)}}>{this._getDescription(league)}</h3>
                            </div>
                            <div className="flex-container" style={{justifyContent:'left'}}>
                                <h1 className={'entry-left'} style={{color : disabled ? colors.theme2.font_color5 : colors.theme2.font_color4}}  onClick={()=>{this.props.onEntriesPress(league)}}>{this._getTitle3(league)}</h1>
                            </div>
                        </div>
                        <div className="flex-container league-container2" >
                            <CCCoinPile textClass={'league-coin-font'} iconClass={'league-coin-icon'} coins={this._getCoins(league)} theme={'dark'} disabled={false} uiDisabled={disabled}/>
                        </div>
                    </div>
                </div>
            </CCErrorBoundary>
        )
    }
}

export default CCLeagueItem


const ccStyles = {
    default : {
        container : {
            height: 70
        },
        leagueIcon : {
            height : 40, width : 40,
        },
        leagueTitle : {
            fontSize : 13
        },
        leagueSubTitle : {
            fontSize : 11,
        },
        entriesLeft : {
            fontSize :13
        },
        coinsPileSize : 's'
    },
    s: {
        container: {
            height: 60
        },
        leagueIcon:{
            height : 30, width :30
        },
        leagueTitle : {
            fontSize :11
        },
        leagueSubTitle : {
            fontSize :10
        },
        entriesLeft:{
            fontSize :11
        },
        coinsPileSize:'xs'
    }
}



// WEBPACK FOOTER //
// ./src/app/components/CCLeagueItem/CCLeagueItem.js